import React, { useState, useContext, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Col, Row, Table } from 'reactstrap';
import _ from 'lodash';
import FHL from './FHL';
import FWB from './FWB';
import FFM from './FFM';
import FSN from './FSN';
import Payments from './Payments';
import Warehouse from './Warehouse';
import Notifications from './Notifications';
import WarehouseCheckIn from './WarehouseCheckIn';
import useBreakpoint from '../../customHooks/useBreakpoint';
import Import from './Import';
import Log from './Log';
import { IMenuItem } from './interfaces';
import useSelections from './useSelections';

import { IMap } from '../../globals/interfaces';
import { formatMawb } from '../../utils';
import FSU from './FSU';
import BackButton from '../custom/BackButton';
import VisualReporting from './VisualReporting';
import { useSearchAwb } from './useSearchAwb';
import useUser from '../../customHooks/useUser';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import { motion, AnimatePresence } from 'framer-motion';
import searchAnimation from '../../assets/lottie/search.json';

export default function SearchAwb() {

    const { user } = useUser();
    const {
        modalSearchAwb: modal,
        setModalSearchAwb: setModal,
        searchAwbNum,
        searchAwbDataMap,
        additionalSearchAwbData,
        loading
    } = useSearchAwb();

    const { breakpoint } = useBreakpoint();
    const [map, setMap] = useState<IMap<IMenuItem>>({});
    const [step, setStep] = useState('');
    const [menu, setMenu] = useState<Array<IMenuItem>>([]);

    useEffect(() => {
        setMap(searchAwbDataMap);

        const array: Array<IMenuItem> = [];
        array.push(searchAwbDataMap.log);

        for (let key in searchAwbDataMap) {
            if (key !== 'log') {
                array.push(searchAwbDataMap[key]);
            }
        }
        array.sort((a, b) => Number(b.hasData) - Number(a.hasData));

        setMenu(array);
        if (array.length > 0) {
            setStep(array[0].key);
        }
    }, [searchAwbDataMap]);

    const toggle = () => setModal(!modal);

    const {
        ffmOptions,
        totalPcs,
        totalWgt,
        origin,
        dest,
        lastArrivalDate,
        lastFreeDate,
        storageStart,
        ffmOption,
        handleSetFfmOption
    } = useSelections(
        // @ts-ignore
        _.get(map, 'ffm.data', [])
    );

    // @ts-ignore
    const fwbWeight: number = _.get(map, 'fwb.data[0].f_weight', null);

    return (
        <StyledModal isOpen={modal} toggle={toggle}>
            <AnimatePresence mode="wait">
                {loading ? (
                    <motion.div
                        key="loading"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <ModalBody>
                            <StyledColCentered>
                                <Lottie
                                    animationData={searchAnimation}
                                    loop={true}
                                />
                            </StyledColCentered>
                        </ModalBody>
                    </motion.div>
                ) : (
                    <motion.div
                        key="content"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <ModalHeader>
                            <Row>
                                <Col md={1}>
                                    <BackButton onClick={() => toggle()} />
                                </Col>
                                <Col md={3}>
                                    Master View: {formatMawb(searchAwbNum)}
                                </Col>
                                <Col md={1}>
                                    Pieces: {_.get(map, 'fwb.data[0].i_total_pieces', null) || _.get(map, 'ffm.data[0].i_actual_piece_count', '')}
                                </Col>
                                <Col md={1}>
                                    Weight: {_.get(map, 'fwb.data[0].f_weight', null) || _.get(map, 'ffm.data[0].f_weight', '')}
                                </Col>
                                <Col md={1}>
                                    Origin: {_.get(map, 'fwb.data[0].s_origin', null) || _.get(map, 'ffm.data[0].s_origin', '')}
                                </Col>
                                <Col md={2}>
                                    Destination: {_.get(map, 'fwb.data[0].s_destination', null) || _.get(map, 'ffm.data[0].s_destination', '')}
                                </Col>
                                <Col md={3}>
                                    Goods: {_.get(map, 'fwb.data[0].s_goods_description', null) || _.get(map, 'ffm.data[0].s_commodity', '')}
                                </Col>
                            </Row>
                        </ModalHeader>
                        <ModalBody>
                            <Row>
                                <StyledCol md={breakpoint ? 12 : 2}>
                                    <Table>
                                        <thead>

                                        </thead>
                                        <tbody>
                                            {/* <tr
                                                onClick={() => setStep('chat')}
                                                className={`text-white ${step === 'chat' ? 'font-weight-bold bg-success' : 'bg-secondary hover-pointer'}`}
                                            >
                                                <td colSpan={2}>Athena</td>
                                            </tr> */}
                                            {
                                                menu.map((m, i) => (
                                                    <tr
                                                        onClick={() => setStep(m.key)}
                                                        className={`text-white ${step === m.key ? 'font-weight-bold bg-success' : (m.hasData || m.key === 'log') ? 'bg-secondary hover-pointer' : 'bg-grey custom-disabled'}`}
                                                        key={i}
                                                    >
                                                        <td>{m.name}</td>
                                                        <td style={{ border: '2px solid white' }}>{m.dataCount || m.data.length}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </StyledCol>
                                <StyledCol md={breakpoint ? 12 : 10}>
                                    {
                                        step === 'log' ?
                                            <Log
                                                data={map.log.data}
                                                user={user}
                                            /> :
                                            step === 'fwb' ?
                                                <FWB
                                                    data={map.fwb.data}
                                                    toggle={toggle}
                                                /> :
                                                step === 'fhl' ?
                                                    <FHL
                                                        data={map.fhl.data}
                                                        toggle={toggle}
                                                    /> :
                                                    step === 'ffm' ?
                                                        <FFM
                                                            data={additionalSearchAwbData.allFfms}
                                                            toggle={toggle}
                                                        /> :
                                                        step === 'payments' ?
                                                            <Payments
                                                                payments={map.payments.data}
                                                                ffms={map.ffm.data}
                                                                fhls={map.fhl.data}
                                                                minCharges={additionalSearchAwbData.minCharges}
                                                                totalWgt={fwbWeight || totalWgt}
                                                                s_mawb={searchAwbNum}
                                                                user={user}
                                                            /> :
                                                            step === 'locations' ?
                                                                <Warehouse
                                                                    data={_.cloneDeep(map.locations.data)}
                                                                    toggle={toggle}
                                                                /> :
                                                                step === 'fsn' ?
                                                                    <FSN
                                                                        data={map.fsn.data}
                                                                    /> :
                                                                    step === 'notifications' ?
                                                                        <Notifications
                                                                            data={map.notifications.data}
                                                                            toggle={toggle}
                                                                        /> :
                                                                        step === 'warehouse' ?
                                                                            <WarehouseCheckIn
                                                                                data={map.warehouse.data}
                                                                            /> :
                                                                            step === 'import' ?
                                                                                <Import
                                                                                    data={map.import.data}
                                                                                /> :
                                                                                step === 'dlv' ?
                                                                                    <FSU
                                                                                        data={map.dlv.data}
                                                                                    /> :
                                                                                    step === 'visualReporting' ?
                                                                                        <VisualReporting
                                                                                            data={map.visualReporting.data}
                                                                                            user={user}
                                                                                        /> :
                                                                                        <h1>Work In Progress</h1>
                                    }
                                </StyledCol>
                            </Row>
                        </ModalBody>
                    </motion.div>
                )}
            </AnimatePresence>
        </StyledModal>
    );
}

const StyledModal = styled(Modal)`
    max-width: 85%;
    height: 80vh;
    max-height: 100%;
`;

const StyledCol = styled(Col)`
    height: calc(100vh - 300px);
    overflow-y: scroll;
`;

const StyledColCentered = styled(StyledCol)`
    display: flex;
    justify-content: center;
    align-items: center;
`;